import { render } from "./Home.vue?vue&type=template&id=1d6806ad"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=1d6806ad&lang=css"
script.render = render

export default script